import script from "./ProductPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductPage.vue?vue&type=script&setup=true&lang=js"

import "./ProductPage.vue?vue&type=style&index=0&id=41eb1b9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41eb1b9a"]])

export default __exports__